import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";
import { useLocation } from "react-router-dom";

const useFamiliaProduto = ({ formikRef, name = 'familiaProdutoId', grupoProduto = 0, gruposProduto, familiasDisponiveis, replicacao = false, salvarLocalStorage, chave }) => {
  const familiaProdutoSelect = useSelect("familiaProdutos");
  const [familiaProduto, setFamiliaProduto] = useState(0);
  const [familiasProduto, setFamiliasProduto] = useState([]);
  const [familiaProdutoTexto, setFamiliaProdutoTexto] = useState()
  const [gruposPorFamilia, setGruposPorFamilia] = useState([]);
  const [onFamilia, setOnFamilia] = useState(false)
  const location = useLocation();
  useEffect(() => {
    const fetchFamiliasProduto = async () => {
      let query = db.familiaProdutos;
      let result = [];

      if (gruposProduto?.length > 0 && !grupoProduto) {
        let idsArray = gruposProduto.map(g => g.id);

        if (idsArray.length > 0) {
          query = query.where('grupoMaterialId').anyOf(idsArray);
        }
      } else if (familiasDisponiveis) {
        query = query.where('id').anyOf(familiasDisponiveis).filter((a) => a.ativo && a.nome != "" && (!grupoProduto || a.grupoMaterialId === grupoProduto));
      } else if (grupoProduto > 0) {
        query = query.where("grupoMaterialId").equals(grupoProduto).filter((a) => a.ativo && a.nome != "");
      } else {
        query = query.filter((a) => a.ativo && a.nome != "");
      }

      if (replicacao)
        query = query.filter((a) => a.replicacaoAtiva !== false);

      await query.each((item) => result.push(item));

      setFamiliasProduto(result);
    };

    fetchFamiliasProduto();
  }, [grupoProduto, gruposProduto, familiasDisponiveis, replicacao]);

  const optionFamiliasProduto = useMemo(() => {
    if (location.pathname === '/tabela-preco/preco-regra') {
      return prepareForOptions((familiasProduto || []).sort((a, b) => a.nome?.localeCompare(b.nome)), ['nome'], 'id');
    }

    return prepareForOptions((familiasProduto || []).sort((a, b) => a.nome?.localeCompare(b.nome)), ['codigo', 'nome'], 'id');
  }, [familiasProduto])

  useEffect(() => {
    async function fetchData() {
      if (familiaProduto && !isNaN(familiaProduto)) {
        const e = await db.familiaProdutos.where({ id: familiaProduto }).first();
        if (e) {
          const c = [];
          await db.familiaProdutos.where({ codigo: e.codigo }).each((a) => c.push(a));
          setGruposPorFamilia(c);
        } else {
          setGruposPorFamilia([]);
        }
      } else {
        setGruposPorFamilia([]);
      }
    }

    fetchData();
  }, [familiaProduto]);

  function onChangeFamiliaProduto(e) {
    setOnFamilia(e.value > 0);
    familiaProdutoSelect.upDateValue(e.value);
    familiaProdutoSelect.upDateDefaultValue(e || "");
    if (e && e.value && salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }
    if (formikRef?.current) {
      formikRef.current.setFieldValue(name, e.value);
      setTimeout(() => formikRef.current.setFieldTouched(name, true));
    }
    setFamiliaProduto(e.value);
    setFamiliaProdutoTexto(e.label)
  }

  function SetSelectFamiliaProduto(id) {
    const familiaProduto = optionFamiliasProduto.find(familia => familia.value === id);
    if (familiaProduto)
      onChangeFamiliaProduto(familiaProduto)
  }

  function CleanForFilter(option) {
    onChangeFamiliaProduto(option);
    if (!option || !option.value) {
      localStorage.removeItem(chave);
    }
  }

  useEffect(() => {
    if(salvarLocalStorage){
      const cidade = localStorage.getItem(chave);

    if (cidade) {
      const filialObj = JSON.parse(cidade);

      onChangeFamiliaProduto(filialObj);
      setFamiliaProduto(filialObj.value);
    }
    }
  }, [])


  return {
    gruposPorFamilia,
    familiasProduto,
    optionFamiliasProduto,
    onChangeFamiliaProduto,
    familiaProduto,
    familiaProdutoSelect,
    setFamiliaProduto,
    SetSelectFamiliaProduto,
    familiaProdutoTexto,
    onFamilia,
    CleanForFilter
  };
}

export default useFamiliaProduto;